export class ArrayHelper {
  static createGroups<T>(arr: T[], maxGroupSize: number): Array<T[]> {
    return Array.from(
      { length: Math.ceil(arr.length / maxGroupSize) },
      (v, i) => arr.slice(i * maxGroupSize, i * maxGroupSize + maxGroupSize)
    )
  }
}
